import { Platform, StatusBar, StyleSheet } from "react-native";
import dimensions from "../../globalStyles/dimensions";
import { Colors } from "../../globalStyles/ColorConfig";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white000,
    paddingTop: 30
  },
  boxStyle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 12,
  },
  conditiontext: {
    fontSize: 14,
    color: Colors.grey200,
    opacity: 0.8,
    letterSpacing: 0.14,
    fontWeight: "300",
  },
  mobileAuthView: {
    flex: 1,
    paddingHorizontal: 25,
    gap: 16,
  },
  authBtn: {
    backgroundColor: Colors.black100,
    borderRadius: 40,
    marginVertical: dimensions.marginVertical,
    borderWidth: 0.5,
    borderColor: Colors.grey300,
  },
  BtnText: {
    color: Colors.white10,
    fontSize: 16,
    fontWeight: "400",
    letterSpacing: 0.16,
  },
  subText: {
    fontSize: 14,
    color: Colors.grey200,
    opacity: 0.8,
    letterSpacing: 0.14,
    paddingLeft: 4,
    textDecorationLine: "underline",
    fontWeight: "300",
  },
  headerText: {
    fontSize: 24,
    fontWeight: "700",
    letterSpacing: 0.24,
    color: Colors.black100,
  },
  subHeader: {
    fontSize: 16,
    fontWeight: "400",
    letterSpacing: 0.16,
    color: Colors.black100,
    lineHeight: 19.84,
  },
  textinputHidden: {
    position: "absolute",
    opacity: 0,
  },
  SplitOTPBoxesContainer: {
    width: "80%",
    flexDirection: "row",
    gap: 10,
  },
  SplitBoxes: {
    borderRadius: 5,
    padding: 12,
    minWidth: 50,
  },
  SplitBoxText: {
    fontSize: 20,
    textAlign: "center",
    color: Colors.black100,
  },
  Wrapper: {
    flex: 1,
    backgroundColor: Colors.black100,
    alignItems: "center",
  },
  ButtonWrapper: {
    paddingHorizontal: 10,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
  BgImg: {
    width: Platform.OS === "web" ? 390 : "100%",
    marginHorizontal: "auto",
    height: "100%",
  },
  LogoWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
    top: "20%",
  },
});
